import React, { Fragment, useState, useEffect } from "react";
import AdministrationHeader from "../../components/header-components/AdministrationHeader";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"; // <-- import styles to be used
import "@fortawesome/fontawesome-svg-core/styles.css";
import HierarchyTree from "../../components/form-components/HierarchyTree";
import TextArea from "../../components/form-components/TextArea";
import EditableTitle from "../../components/form-components/EditableTitle";
import { useLocation } from "react-router-dom";
import AddComponent from "./AddComponent";
import Modal from "../../components/ui-components/Modal";
import ComponentButtons from "../../components/ui-components/ComponentButtons.js";
import { useOutletContext} from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const OrganizeComponents = () => {
	const location = useLocation();
	const [mergeFromComponent, setMergeFromComponent] = useState({});
	const [mergeToComponent, setMergeToComponent] = useState({});

	const [addComponentWindow, setAddComponentWindow] = useState(false);
	const toggleAddComponentWindow = () =>
		setAddComponentWindow(!addComponentWindow);

	const [mergeComponentWindow, setMergeComponentWindow] = useState(false);
	const toggleMergeComponentWindow = () =>
		setMergeComponentWindow(!mergeComponentWindow);

	const [confirmMergeComponentWindow, setConfirmMergeComponentWindow] =
		useState(false);
	const toggleConfirmMergeComponentWindow = () =>
		setConfirmMergeComponentWindow(!confirmMergeComponentWindow);

	const [removeComponentWindow, setRemoveComponentWindow] = useState(false);
	const toggleRemoveComponentWindow = () =>
		setRemoveComponentWindow(!removeComponentWindow);

	const toggleAlertWindow = () => setAlertWindow(!alertWindow);
	const [alertWindow, setAlertWindow] = useState(false);

	const [hierarchy, setHierarchy] = useState([]);
	const [hierarchyLoaded, setHierarchyLoaded] = useState(false);

	const [componentRequest, setComponentRequest] = useState({
		component: {
			id: -1,
			name: "",
			description: "",
			parent_id: 0,
			tree_order: 0,
			customer_id: 0,
		},
		isLoaded: false,
	});

	const { jwt } = useOutletContext();

	function getRequestOptions() {
		if (jwt === "") return;
		
		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "GET";

		let requestOptions = {
			method: method,
			headers: headers,
		};

		return requestOptions;
	}

	function retrieveHierarchy() {
		if (jwt === "") return;

		fetch(API_URL + "/get-component-hierarchy", getRequestOptions())
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				setHierarchy([json.ComponentHierarchy]);
				setHierarchyLoaded(true);
			});
	}

	useEffect(() => {
		retrieveHierarchy();
	// The fetchers are plain function declarations, so they are re-created on every
	// render; the deps below are the inputs that should actually trigger a refetch.
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [jwt, location]);

	function retrieveComponent(componentID) {
		if (jwt === "") return;

		fetch(API_URL + "/get-component/" + componentID, getRequestOptions())
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				setComponentRequest({
					component: {
						id: json.Component.id,
						name: json.Component.name,
						description: json.Component.description,
						parent_id: json.Component.parent_id,
						tree_order: json.Component.tree_order,
						customer_id: json.Component.customer_id,
					},
					isLoaded: true,
				});
			});
	}

	function mergeComponents(fromID, toID) {
		toggleMergeComponentWindow();

		var fromComponent = findInHierarchy(fromID, hierarchy);

		if (isPartOfHierarchy(toID, fromComponent.children)) {
			toggleAlertWindow();
			return;
		} else {
			setMergeFromComponent(findInHierarchy(fromID, hierarchy));
			setMergeToComponent(findInHierarchy(toID, hierarchy));
			toggleConfirmMergeComponentWindow();
		}
	}

	function confirmMergeComponents() {
		if (jwt === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PATCH";

		const requestBody = {
			from_id: mergeFromComponent.id,
			to_id: mergeToComponent.id,
		};

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/merge-components", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
				selectNode(mergeToComponent.id.toString());
			});

		toggleConfirmMergeComponentWindow();
	}

	function findInHierarchy(componentID, hierarchy) {
		var result = null;
		for (let i = 0; i < hierarchy.length; i++) {
			if (hierarchy[i].id === componentID) {
				result = hierarchy[i];
			}

			if (hierarchy[i].children !== undefined && result == null) {
				result = findInHierarchy(componentID, hierarchy[i].children);
			}
		}

		return result;
	}

	function isPartOfHierarchy(componentID, hierarchy) {
		var result = false;
		for (let i = 0; i < hierarchy.length; i++) {
			if (hierarchy[i].id === componentID) {
				result = true;
			}

			if (hierarchy[i].children !== undefined && result === false) {
				result = isPartOfHierarchy(componentID, hierarchy[i].children);
			}
		}

		return result;
	}

	function removeComponent(componentID) {
		if (jwt === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PUT";

		const requestBody = {
			id: componentID,
		};

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/remove-component", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
				// selectNode((mergeToComponent.id).toString());
			});

		toggleRemoveComponentWindow();
	}

	function selectNode(componentID) {
		if (componentID !== undefined) {
			if (mergeComponentWindow) {
				mergeComponents(component.id, componentID);
			}
			retrieveComponent(componentID);
		} else {
			setComponentRequest({
				component: {
					...component,
					id: -1,
				},
				isLoaded: false,
			});
		}
	}

	const handleChange = (event) => {
		const { name, value } = event.target;
		setComponentRequest({
			...componentRequest,
			component: {
				...component,
				[name]: value,
			},
		});
	};

	// add a new component
	function saveComponent(name, description, parentID, treeOrder, customerID) {
		if (jwt === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PUT";

		const requestBody = {
			name: name,
			description: description,
			parent_id: parentID,
			treeOrder: treeOrder,
			customer_id: customerID,
		};

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/add-component", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
				selectNode(json.Component.id.toString());
			});

		toggleAddComponentWindow();
	}

	const updateRecord = () => {
		if (jwt === "") return;

		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PUT";

		if (component.id > 0) {
			method = "PATCH";
		}

		const requestBody = componentRequest.component;

		requestBody.id = parseInt(componentRequest.component.id, 10);

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/set-component", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
			});
	};

	function updateHierarchy(hierarchy) {
		if (jwt === "") return;
		
		const headers = new Headers();
		headers.append("Content-Type", "application/json");
		headers.append("Authorization", "Bearer " + jwt);

		let method = "PUT";

		const requestBody = hierarchy;

		let requestOptions = {
			body: JSON.stringify(requestBody),
			method: method,
			headers: headers,
		};

		fetch(API_URL + "/set-component-hierarchy", requestOptions)
			.then((response) => {
				if (response.status !== "200") {
					// let err = Error;
					// err.message = "Invalid response code: " + response.status;
					// setError(err);
				}
				return response.json();
			})
			.then((json) => {
				retrieveHierarchy();
			});
	}

	const wrapperSetHierarchy = (val) => {
		setHierarchy([...val]);
		updateHierarchy(val);
	};

	const component = componentRequest.component;
	const componentLoaded = componentRequest.isLoaded;
	const mergeIcon = icon({ name: "layer-group", style: "solid" });
	const removeIcon = icon({ name: "triangle-exclamation", style: "solid" });

	const headerOptions = {
		componentSelected: componentRequest.component.id !== -1,
		nonTopComponentSelected:
			componentRequest.component.id !== -1 &&
			componentRequest.component.parent_id !== -1,
		componentName: component.name,
	};

	return (
		<Fragment>
			<AdministrationHeader title="IT Component structure" subTitle="Define the generic IT components that are being used in the organisation" className="text-text-3" />
			<div className="flex flex-1 h-full bg-white">
				<div className="flex flex-1 flex-col">
					<ComponentButtons
						addComponent={() => toggleAddComponentWindow()}
						mergeComponent={() => toggleMergeComponentWindow()}
						removeComponent={() => toggleRemoveComponentWindow()}
						headerOptions={headerOptions}
						entity={"component"}
					/>
					<div className="flex flex-1">
						<div className="h-[calc(100vh-275px)] flex-1 overflow-auto mt-8">
							<HierarchyTree
								treeData={hierarchy}
								isLoaded={hierarchyLoaded}
								selectNode={selectNode}
								updateHierarchy={wrapperSetHierarchy}
								className="z-0"
								selectedKeys={[component.id]}
								mergeMode={mergeComponentWindow}
								draggable={true}
								showTags={false}
							/>
						</div>
					</div>
				</div>
				<div className="flex-none w-[510px] border-l border-border p-10">
					{/* <div className="flex-none w-[510px] border-l border-coolgrey8 p-10"> */}
					<EditableTitle
						name={"name"}
						value={component.name}
						isLoaded={componentLoaded}
						onChange={handleChange}
						onBlur={updateRecord}
					/>
					<TextArea
						type="text"
						name={"description"}
						id="description"
						isLoaded={componentLoaded}
						value={component.description}
						className="bg-surface-2 w-[420px] border border-border text-text text-sm rounded-ctrl focus:ring-primary focus:border-primary block p-2.5"
						title="Description"
						placeholder=""
						onChange={handleChange}
						onBlur={updateRecord}
						rows={10}
						required
					/>
				</div>
				<AddComponent
					show={addComponentWindow}
					close={toggleAddComponentWindow}
					saveComponent={saveComponent}
					parentComponent={component}
				/>
				<Modal
					show={mergeComponentWindow}
					close={toggleMergeComponentWindow}
					title={"Merge component " + component.name}
					description={
						"Select the component to merge " +
						component.name +
						" into. All subcomponents of " +
						component.name +
						" will be moved to the selected component."
					}
					warningMessage=""
					confirmButton=""
					cancelButton="Cancel"
					icon={mergeIcon}
					alertIcon={false}
					modal={false}
				/>
				<Modal
					show={removeComponentWindow}
					close={toggleRemoveComponentWindow}
					title={"Remove component " + component.name}
					description={
						"Are you sure you want to remove component " +
						component.name +
						"? All of the data will be permanently removed."
					}
					warningMessage="This action cannot be undone."
					confirmButton="Remove component"
					cancelButton="Cancel"
					confirmAction={() => removeComponent(component.id)}
					icon={removeIcon}
					alertIcon={true}
					modal={true}
				/>
				<Modal
					show={confirmMergeComponentWindow}
					close={toggleConfirmMergeComponentWindow}
					title={
						"Merge component " +
						mergeFromComponent.name +
						" into component " +
						mergeToComponent.name
					}
					description={
						"Are you sure you want to permanently move all subcomponents of " +
						mergeFromComponent.name +
						" into component " +
						mergeToComponent.name +
						"?"
					}
					warningMessage="This action cannot be undone."
					confirmButton="Merge component"
					cancelButton="Cancel"
					confirmAction={() => confirmMergeComponents(component.id)}
					icon={removeIcon}
					alertIcon={true}
					modal={true}
				/>
				<Modal
					show={alertWindow}
					close={toggleAlertWindow}
					title={"Unable to merge"}
					description={
						"Cannot merge an component into one of its subcomponents."
					}
					warningMessage=""
					confirmButton=""
					cancelButton="Cancel"
					icon={mergeIcon}
					alertIcon={true}
					modal={true}
				/>
			</div>
		</Fragment>
	);
};

export default OrganizeComponents;
